import { createContext } from 'use-context-selector';
import { WizardState } from './types';
import { defaultWizardProviderValues } from './defaultState';

const ProcessEngineWizardContext = createContext<WizardState>(defaultWizardProviderValues);

export { ProcessEngineWizardContext };
